<div class="homepage-filtered-map">
  <div class="filters-container">
    <h1 [innerHTML]="'HOMEPAGE.MAP.header' | translate"></h1>
    <p [innerHTML]="'HOMEPAGE.MAP.content' | translate"></p>

    <div class="buttons">
      <a class="btn"
         [ngClass]="{ active: selectedFilter == 'event' }"
         (click)="changeSelectedFilter('event')"
         [innerHTML]="'HOMEPAGE.MAP.buttons.events' | translate"></a>

      <a class="btn"
         [ngClass]="{ active: selectedFilter == 'project' }"
         (click)="changeSelectedFilter('project')"
         [innerHTML]="'HOMEPAGE.MAP.buttons.projects' | translate"></a>

      <a class="btn"
         [ngClass]="{ active: selectedFilter == 'ambassador' }"
         (click)="changeSelectedFilter('ambassador')"
         [innerHTML]="'HOMEPAGE.MAP.buttons.ambassadors' | translate"></a>
    </div>
  </div>

  <div class="map-container">
    <div *ngIf="loadingData" class="map-loading-indicator">
      <div class="loader"></div>
    </div>

    <div
        id="homepage-filtered-map-container"
        leaflet
        [leafletOptions]="mapOptions()"
        [leafletMarkerCluster]=""
        [leafletMarkerClusterOptions]="markersClusterOptions()"
        (leafletMapReady)="onMapLoaded($event)"
        (leafletMarkerClusterReady)="onMarkerClusterLoaded($event)"
    ></div>
  </div>
</div>
